module.exports = "./img/desktop_logo.58a31d6.png";